import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import { ReactComponent as TelegramIcon } from 'assets/svg/telegram.svg';
import { useSearchAiPluginStore } from 'store/searchAiPluginStore';

export const InquiryForm = () => {
    const { customization } = useSearchAiPluginStore();

    return (
        <div className=" max-w-md mx-auto bg-white">
            <div className="text-center mb-6 bg-gradient-to-r from-[#F5F5F5]/100 to-blue-100/40 rounded-lg p-8 border-b ">
                <TelegramIcon className="mx-auto" style={{ color: customization.themeColor }} />

                <h2 className="text-xl font-semibold mb-2">{customization.formTitle}</h2>
                <p className="text-gray-600 text-sm">{customization.formDescription}</p>
            </div>

            <form className="space-y-4 px-8 py-0 pb-8">
                <div>
                    <label htmlFor="name" className="block text-sm font-bold text-gray-700">
                        Your Name
                    </label>
                    <input
                        type="text"
                        id="name"
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500"
                        placeholder="John Doe"
                        readOnly
                    />
                </div>

                <div>
                    <label htmlFor="email" className="block text-sm font-bold text-gray-700">
                        Email
                    </label>
                    <input
                        type="email"
                        id="email"
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500"
                        placeholder="Input email"
                        readOnly
                    />
                </div>

                <div>
                    <label htmlFor="phone" className="block text-sm font-bold text-gray-700">
                        Phone Number
                    </label>
                    <div className="mt-1 flex">
                        <select
                            className="inline-block w-24 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500"
                            disabled
                        >
                            <option>+34</option>
                        </select>
                        <input
                            type="tel"
                            id="phone"
                            className="ml-2 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500"
                            placeholder="Input phone number (Optional)"
                            readOnly
                        />
                    </div>
                </div>

                <div>
                    <label htmlFor="message" className="block text-sm font-bold text-gray-700">
                        Message
                    </label>
                    <textarea
                        id="message"
                        rows={6}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500"
                        placeholder="Input your message"
                        required
                        readOnly
                    />
                </div>

                <button
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-l font-semibold text-white"
                    style={{ backgroundColor: customization.themeColor }}
                    disabled
                >
                    <span className="mr-2">
                        <ChatBubbleIcon />
                    </span>
                    Request More Info
                </button>
            </form>
        </div>
    );
};
